import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecureInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "secureInformation",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16818",
		"data-name": "Group 16818",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12464",
				"data-name": "Path 12464",
				d: "M10,10.447h4a1,1,0,0,1,1,1V14.5a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V11.447a1,1,0,0,1,1-1Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12465",
				"data-name": "Path 12465",
				d: "M10.316,10.447V9.184a1.684,1.684,0,0,1,3.368,0v1.261",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12466",
				"data-name": "Path 12466",
				d: "M5.973,5.067l5.342-1.946a2,2,0,0,1,1.369,0l5.342,1.946A3,3,0,0,1,20,7.886v4.872c0,3.581-1.828,5.05-7.005,7.981a2.022,2.022,0,0,1-1.99,0C5.828,17.808,4,16.339,4,12.758V7.886A3,3,0,0,1,5.973,5.067Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12467",
		"data-name": "Path 12467",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgSecureInformation;
